<template>
    <div class="view-report-page">
        <ViewTransformatorReportStaticHeaderContent
            :report-number="reportNumber"
            :report-type="reportTypeAsNumber"
            :transformer-id="transformerId"
        />
        <div class="view-report-page__content">
            <ViewReportActionsSection
                :report-number="reportNumber"
                :report-type="reportTypeAsNumber"
                :component-sid="transformerId"
                :component-type="ComponentType.Transformer"
            />
            <MasterDataPanel
                v-if="transformerId"
                :transformer-id="transformerId"
            />
            <ViewReportOilAnalysisSection
                v-if="reportTypeAsNumber === ReportType.OilAnalysis"
                :report-number="reportNumber"
                :report-type="reportTypeAsNumber"
                :component-sid="transformerId"
            />
            <ViewReportVisualInspectionSection
                v-if="reportTypeAsNumber === ReportType.VisualInspection && visualInspectionData"
                :report-number="reportNumber"
                :visual-inspection-data="visualInspectionData"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import ViewTransformatorReportStaticHeaderContent from '@/pages/reports/view-report-page/transformator/ViewTransformatorReportStaticHeaderContent.vue'
import { computed, toRefs } from 'vue'
import ViewReportActionsSection from '@/pages/reports/view-report-page/common/ViewReportActionsSection.vue'
import MasterDataPanel from '@/pages/transformers/condition-status/sections/master-data/MasterDataPanel.vue'
import { useReportGetQuery } from '@/api/queries/reports/useReportGetQuery'
import ViewReportOilAnalysisSection from '@/pages/reports/view-report-page/transformator/sections/ViewReportOilAnalysisSection.vue'
import ViewReportVisualInspectionSection from '@/pages/reports/view-report-page/transformator/sections/ViewReportVisualInspectionSection.vue'
import { ReportType } from '@/configuration/report/report-types'
import { ComponentType } from '@/configuration/component/component-types'
import { AnalysisType } from '@/configuration/analysis/analysis-types'

const props = defineProps<{
    transformerId: string
    reportNumber: string
    reportType: string
}>()

const { transformerId, reportNumber, reportType } = toRefs(props)
const reportTypeAsNumber = computed(() => Number(reportType.value))

const { data } = useReportGetQuery(reportNumber, reportTypeAsNumber, transformerId)

const visualInspectionData = computed(() => {
    if (!data.value?.data) {
        return undefined
    }

    return data.value.data.find((e) => e.analysisType === AnalysisType.VisualInspection)
})
</script>

<style scoped lang="scss">
.view-report-page {
    display: flex;
    flex-direction: column;

    max-height: calc(100vh - $navbar-height * 2);

    &__content {
        @include spacing-page;
        overflow-y: auto;

        display: flex;
        flex-direction: column;
        gap: $spacing-m;
    }
}
</style>
